// Color mapping based on categories, which are clusterd
export const colorMapping = (categoryId, hex = false) => {
  switch (categoryId) {
    case 1:
    case 4:
    case 5:
    case 7:
    case 9:
    case 10:
    case 11:
    case 23:
      return hex ? '#FF4CED' : { r: 1, g: 0.29, b: 0.93, a: 1 };
    case 6:
    case 17:
    case 19:
    case 21:
      return hex ? '#E7772F' : { r: 0.91, g: 0.47, b: 0.18, a: 1 };
    case 2:
    case 14:
    case 16:
      return hex ? '#E7F669' : { r: 0.91, g: 0.96, b: 0.41, a: 1 };
    case 8:
    case 13:
    case 15:
    case 22:
      return hex ? '#91E464' : { r: 0.57, g: 0.89, b: 0.39, a: 1 };
    case 18:
    case 24:
      return hex ? '#70F1EB' : { r: 0.44, g: 0.95, b: 0.92, a: 1 };
    case 12:
    case 20:
      return hex ? '#578DF0' : { r: 0.34, g: 0.55, b: 0.94, a: 1 };
    default:
      return hex ? '#FF4CED' : { r: 1, g: 0.29, b: 0.93, a: 1 };
  }
};

// const randomMetaData = {
//   userResidence: [
//     'Berlin, Deutschland',
//     'Hamburg, Deutschland',
//     'Köln, Deutschland',
//     'München, Deutschland'
//   ][Math.round(Math.random() * 3)],
//   userAgeGroup: ['0-20', '21-40', '41-60', '60+'][Math.round(Math.random() * 3)],
//   userGender: ['m', 'f', 'd'][Math.round(Math.random() * 3)]
// };

export const generateSpherePoints = (data, minDistance = 2) => {
  const points = [];
  if (data.length < 0) return [];

  function haversineDistance(coord1, coord2) {
    const toRadians = degrees => (degrees * Math.PI) / 180;
    const R = 100; // Globe gl radius

    const dLat = toRadians(coord2[1] - coord1[1]);
    const dLng = toRadians(coord2[0] - coord1[0]);

    const lat1 = toRadians(coord1[1]);
    const lat2 = toRadians(coord2[1]);

    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.sin(dLng / 2) * Math.sin(dLng / 2) * Math.cos(lat1) * Math.cos(lat2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

    return R * c; // Distance in kilometers
  }

  for (let i = 0; i < data.length; i += 1) {
    const lat = Math.asin(Math.random() * 2 - 1) * (180 / Math.PI);
    const lng = Math.random() * 360 - 180;

    const newPoint = {
      ...data[i],
      lat,
      lng,
      alt: [0.1, 0.15, 0.18, 0.2, 0.22][Math.round(Math.random() * 3)],
      radius: 1,
      color: colorMapping(data[i].categories[0])
      // ...randomMetaData
    };

    // Check if the new point is far enough from all existing points
    const isFarEnough = points.every(point => {
      const distance = haversineDistance([point.lng, point.lat], [newPoint.lng, newPoint.lat]);
      return distance >= minDistance;
    });

    if (isFarEnough) {
      points.push(newPoint);
    }
  }

  return points;
};
